import { MetricName } from '@canvas/frontend-metrics';

import { defineMetric, type MetricMetadataBase } from '../define-metric';
import type { FrameState } from '../stabilized-scheduler';

export function collectEntryColumnCheckboxInputs(tbody: HTMLElement): HTMLInputElement[] {
  return Array.from(tbody.querySelectorAll('input[type="checkbox"]')).filter(
    (el) => el.closest('[data-entry-id]') !== null
  ) as HTMLInputElement[];
}

export function getDomRowCheckboxMatchState(
  tableRoot: HTMLElement,
  expectChecked: boolean
): { inputCount: number; allMatch: boolean } {
  const tbody = tableRoot.querySelector('tbody');

  if (!tbody) {
    return { inputCount: 0, allMatch: false };
  }

  const inputs = collectEntryColumnCheckboxInputs(tbody);

  if (inputs.length === 0) {
    return { inputCount: 0, allMatch: false };
  }

  const allMatch = inputs.every((input) => input.checked === expectChecked);
  return { inputCount: inputs.length, allMatch };
}

export function rowCheckboxFrameState(
  tableRoot: HTMLElement,
  expectChecked: boolean
): FrameState {
  const { inputCount, allMatch } = getDomRowCheckboxMatchState(tableRoot, expectChecked);

  if (inputCount === 0 || !allMatch) {
    return { done: false, stabilityKey: null };
  }

  return { done: true, stabilityKey: String(inputCount) };
}

export interface HeaderCheckboxData {
  tableRoot: HTMLElement | null;
  expectChecked: boolean;
}

export type HeaderCheckboxMetadata = MetricMetadataBase;

export const headerCheckboxMetric = defineMetric<
  HeaderCheckboxData,
  HeaderCheckboxMetadata
>({
  metricName: MetricName.DATABASE_HEADER_CHECKBOX_INTERACTION_TIME,
  buildProbe: (probeData) => {
    if (!probeData.tableRoot) {
      return () => ({ done: false, stabilityKey: null });
    }

    const tableRoot = probeData.tableRoot;

    return () => rowCheckboxFrameState(tableRoot, probeData.expectChecked);
  },
  buildMetadata: () => ({
    interactionTimingSource: 'dom-row-checkboxes-sync'
  })
});
